export default __webpack_public_path__ + "static/media/lory.d8d08d75.png";